import KpiAssetRow from "./KpiAssetRow";

const EMPTY_COPY = {
  "with-assets": {
    title: "No KPIs have assets yet",
    hint: "Switch to All KPIs, expand a KPI and click Add to create assets.",
  },
  "with-sub-kpis": {
    title: "No KPIs have global assets yet",
    hint: "Switch to All KPIs, expand a KPI and click Add to create global assets.",
  },
  default: {
    title: "No KPIs match this filter",
    hint: "Try adjusting your search or filter.",
  },
};

/** KPI list: header, rows, empty state. */
export default function KpiList({
  displayList,
  kpiView,
  kpiAssetMap,
  sources,
  selectedFYId,
  onSaved,
  isViewOnly,
  canCreate,
  canUpdate,
  canDelete,
}) {
  if (displayList.length === 0) {
    const copy = EMPTY_COPY[kpiView] || EMPTY_COPY.default;
    return (
      <div className="kpa-empty-state">
        <div style={{ fontSize: 32, marginBottom: 10, opacity: 0.3 }} aria-hidden="true">🏭</div>
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--kpa-slate-400)", marginBottom: 6 }}>{copy.title}</div>
        <div style={{ fontSize: 12, color: "var(--kpa-slate-300)" }}>{copy.hint}</div>
      </div>
    );
  }

  return (
    <>
      <div className="kpa-list-header">
        <span className="kpa-list-header-label">KPI Title</span>
        <span style={{ fontSize: 10, color: "var(--kpa-slate-400)" }}>
          {displayList.length} KPI{displayList.length !== 1 ? "s" : ""}
        </span>
      </div>
      <div style={{ maxHeight: 620, overflowY: "auto" }}>
        {displayList.map((q, idx) => (
          <KpiAssetRow
            key={q.questionId}
            kpi={q}
            assets={kpiAssetMap[q.questionId] || []}
            sources={sources}
            selectedFYId={selectedFYId}
            onSaved={onSaved}
            disabled={isViewOnly}
            isLast={idx === displayList.length - 1}
            canCreate={canCreate}
            canUpdate={canUpdate}
            canDelete={canDelete}
          />
        ))}
      </div>
    </>
  );
}
